import React from 'react';
import { Breadcrumb } from 'antd';
import { ChevronRightIcon } from '../assets/icons/icons';
import { Link } from 'react-router-dom';

interface BreadcrumbItem {
  title: string;
  href?: string;
  state?: unknown;
}

interface BreadcrumbsProps {
  items: BreadcrumbItem[];
}

const Breadcrumbs: React.FC<BreadcrumbsProps> = ({ items }) => {
  return (
    <Breadcrumb
      className='zl-custom-breadcrumbs'
      separator={
        <ChevronRightIcon
          fill='var(--gray-600)'
          width={16}
          height={15}
          className='breadcrumb-icon'
        />
      }
    >
      {items.map((item, index) => (
        <Breadcrumb.Item key={index}>
          {item.href ? (
            <Link to={item.href} state={item.state ?? undefined}>
              {item.title}
            </Link>
          ) : (
            item.title
          )}
        </Breadcrumb.Item>
      ))}
    </Breadcrumb>
  );
};

export default Breadcrumbs;
